import Vue from "vue";
import Vuex from "vuex";
import application from "./modules/application";
import { dialog } from "./modules/dialog.module";
import { communication } from "./modules/communication.module";
import questions from "./modules/questions";
import { steps } from "./modules/steps.module";
import { belongings } from "./modules/belongings.module";

Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    // give each module a unique name which is used inside the .vue file
    application: application,
    questions: questions,
    steps: steps,
    communication: communication,
    dialog: dialog,
    belongings: belongings,
  },
});
